export default __webpack_public_path__ + "b8b6598.png";